import nativeCommsMessageTypes from "../../../nativeComms/nativeCommsMessageTypes";

export default [
  // Timeline Menu
  nativeCommsMessageTypes.MAKE_CONSECUTIVE,
  nativeCommsMessageTypes.MAKE_DEPENDENT
];
